/**
 * Agent API服务
 */
import request from '@/common/request';

const API_BASE_URL = 'https://admin.saas.360.cn/api/qcms-console';

const get = async (url, params) => {
  try {
    return await request.get(url, { params });
  } catch (error) {
    return error;
  }
};

/**
 * 获取Agent列表数据
 * @returns {Promise<Object>} 返回包含featuredAgents、moreAgents和agentCategories的数据
 */
export const fetchAgentList = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/nami-agent-list.json`, {
      method: 'GET',
      credentials: 'omit',
    }).then(res => res.json());

    // 检查响应状态
    if (response.code !== 0 && response.errno !== 0) {
      throw new Error(response.message || response.errmsg || '获取数据失败');
    }

    const result = response.data || response;
    return result;
  } catch (error) {
    console.error('获取Agent列表失败:', error);
    throw error;
  }
};

export const fetchUserInfoData = async () => {
  const response = await get(`/user/info`);
  return response;
};
